import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../shared/button/button";
import { IMAGE_DEFAULT_ERROR_BOUNDARY } from "@/main/services/constants";
import { getTranslateByKey } from "@/main/services/utils";
import { RoutesConstants } from "@/main/routes/routesConstants";
import * as S from "./styles";

interface LayoutErrorScreenProps {
	message?: string;
	returnTo?: string;
}

function LayoutErrorScreen({ message, returnTo = RoutesConstants.home }: LayoutErrorScreenProps) {
	const navigate = useNavigate();
	const returnsHome = returnTo === RoutesConstants.home;

	function handleClickBack(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		e.preventDefault();
		e.stopPropagation();
		navigate(returnTo);
	}
	const messageError = message ?? getTranslateByKey("information.anUnexpectedErrorOccurredPleaseTryAgainLater", true);

	return (
		<S.Container>
			<S.ImageError src={IMAGE_DEFAULT_ERROR_BOUNDARY} alt={messageError} />
			<S.MessageError>{messageError}</S.MessageError>
			<Button
				id={returnsHome ? "id-errorScreen-btn-home" : "id-errorScreen-btn-back"}
				type="button"
				onClick={handleClickBack}
			>
				{getTranslateByKey(returnsHome ? "information.backToHome" : "information.back")}
			</Button>
		</S.Container>
	);
}

export default LayoutErrorScreen;
